module.exports = __webpack_public_path__ + "static/media/ipadstand-piko-600w.e12290f7.png";